/* eslint-disable class-methods-use-this */
import React from 'react';
import framework from 'utils/framework';
import BaseClass from 'components/BaseClass';
import HappeningNonContent from 'components/HappeningNonContent';
import { mediaQueries } from 'style/config';

const { wrapComponent } = framework;

class HappeningNonContentPage extends BaseClass {
    render() {
        return (
            <div css={styles.wrapper}>
                <HappeningNonContent />
            </div>
        );
    }
}

const styles = {
    wrapper: {
        [mediaQueries.sm]: {
            minHeight: 'calc(100vh - 300px)'
        }
    }
};

export default wrapComponent(HappeningNonContentPage, 'HappeningNonContentPage');
